import React, {FC} from 'react'
import Lottie from "react-lottie";

type props = {
    loop?: boolean,
    src: string,
    isStopped?: boolean,
    isPaused?: boolean,
    width?: number,
    height?: number
}
const LottieLoader: FC<props> = ({
                                     loop = false,
                                     src,
                                     isStopped = false,
                                     isPaused = false,
                                     height,
                                     width,
                                 }) => {
    const defaultOptions = {
        loop: loop,
        autoplay: true,
        animationData: src,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };
    return <Lottie height={height}
                   width={width}
                   options={defaultOptions}
                   isClickToPauseDisabled={true}
                   isStopped={isStopped}
                   isPaused={isPaused}/>

}
export default LottieLoader;
